import React, { useEffect, useState } from "react";
import { Space, Table, Tabs, Tooltip } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import ViewButton from "../../../components/Dashboard/ViewButton";
import {
  getcancelhistory,
  getcancelhistorysearch,
} from "../../../store/BookingHistory/BookingHistorySlice";
import { savequeryid } from "../../../store/Queries/QueriesSlice";
import CustomeHeader from "../../../components/Admin/Common/CustomeHeader";
import { MainContainer } from "../../../StyledComponents/Dashboard";

import { useDispatch, useSelector } from "react-redux";
import { authuser } from "../../../store/Authentication/AuthSlice";
import { formatrates } from "../../../functions/Utils";
import { FcViewDetails } from "react-icons/fc";
// import airline from "../../assets/images/active-flight-icon.svg";
import {
  DateSection,
  FilterSection,
  FlexContainer,
  LabelItem,
  RightSection,
  SpinContainer,
} from "../../../StyledComponents/Queries";

import FilterDatePicker from "../../../components/Admin/Common/FilterDatePicker";
import airline from "../../../assets/images/active-flight-icon.svg";
import shipicon from "../../../assets/images/active-ship-icon.svg";
import SearchBox from "../../../components/Admin/Common/SearchBox";
import { set } from "zod";

import moment from "moment";
import CancelledBookingDetailsModal from "./CancelledBookingDetailsModal";

// The cancelled-bookings API (getdeletebooking) returns air AND ocean bookings
// in one list; each record is tagged with `carrier_type` ("Air Cargo" /
// "Ocean Cargo"). This splits the single dataset so the Air/Ocean toggle can
// show each cargo type in its own table. Falls back to bookeditem.cargoType,
// and treats anything that isn't explicitly ocean as air (the default tab).
const isOceanRecord = (record) => {
  let bookeditem = record?.bookeditem;
  if (typeof bookeditem === "string") {
    try {
      bookeditem = JSON.parse(bookeditem);
    } catch (e) {
      bookeditem = {};
    }
  }
  const type = (record?.carrier_type || bookeditem?.cargoType || "").toLowerCase();
  return type.includes("ocean");
};

const Bookingdeletetable = () => {
  const [data, setData] = useState([]);
  const [state, setState] = useState({
    filter_value: "",
    from_date: "",
    to_date: "",
    status: null,
  });
  const [searchValue, setSearchValue] = useState("");

  let debounceTimer = null;

  const [pageSize, setPageSize] = useState(10); // Number of rows per page
  const [currentPage, setCurrentPage] = useState(1);
  const [openview, setOpenview] = useState(false);
  const [delqueryid, setDelqueryid] = useState(null);
  // Whether the row being viewed is an ocean booking — picks which field set
  // (air vs ocean) the detail modal renders.
  const [viewIsOcean, setViewIsOcean] = useState(false);
  // `deletedAt` only exists on the list row (the single-booking endpoint
  // doesn't return it), so it's handed to the modal for its "Cancelled On".
  const [viewCancelledAt, setViewCancelledAt] = useState(null);
  // Active cargo tab. "Air Cargo" | "Ocean Cargo" — same labels the Booking
  // History toggle (BookedList.jsx) uses.
  const [selectedTab, setSelectedTab] = useState("Air Cargo");
  const dispatch = useDispatch();
  console.log(data, "data");

  const userrole = useSelector(authuser)
  console.log(userrole,"userrole");
  const fetchCancelHistory = () => {
    dispatch(getcancelhistory())
      .then((res) => {
        console.log("Cancelled bookings:", res?.payload);

        setData(res?.payload?.data?.data);
      })
      .catch((err) => {
        console.error("Error fetching cancel history:", err);
      });
  };
  useEffect(() => {
    fetchCancelHistory();
  }, []);

  const navigate = useNavigate();

  const parseJSON = (jsonString) => {
    try {
      return typeof jsonString === "string"
        ? JSON.parse(jsonString)
        : jsonString;
    } catch (e) {
      return {};
    }
  };

  const handleView = (record) => {
    console.log(record,record?.markupResult, "record");
    const payload = { queryId: record?.queryId };
    const ocean = isOceanRecord(record);
    setViewIsOcean(ocean);
    setDelqueryid(record?.queryId);
    setViewCancelledAt(record?.deletedAt || null);
    // The modal fetches by its `queryid` prop, but keep redux in step with the
    // row being viewed so any other flow reading getqueryId (payment, confirm)
    // can't act on a stale id left over from a previously-viewed booking.
    dispatch(savequeryid(record?.queryId));
    // navigate(`/booking-delete-view`);
    setOpenview(true);
    // navigate("/bookingdeletehistory/booking-deleted-details", {
    //   state: { queryId: record?.queryId },
    // });

    //   dispatch(getsinglecancelbookingdata(payload))
    // .then((res) => {
    //   if (res.payload) {
    //     console.log("Cancelled booking data:", res.payload);
    //     // You can navigate or update state here
    //   } else {
    //     console.warn("No data returned");
    //   }
    // })
    // .catch((error) => {
    //   console.error("Error fetching cancelled booking:", error);
    // });

    // navigate("/booking-view?queryId=" + record?.queryId);
  };
  const handledetails = (record) => {
    console.log(record, "record");
    // navigate("/booking-view?queryId=" + record?.queryId);
  };

  const columns = (currentPage, pageSize) => [
    {
      title: "Sr. No.",
      key: "slno",
      render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: "Cargo",
      key: "cargo",
      render: (rowdata) => {
        const bookeditem = parseJSON(rowdata?.bookeditem);
        console.log(bookeditem,"bookeditem");
        return (
          <div className="rounded-lg w-14 h-14 flex items-center justify-center">
            <img
              src={bookeditem?.carrierLogo || airline}
              alt="Airline Logo"
              className="rounded-lg overflow-hidden w-full"
            />
          </div>
        );
      },
    },
    {
      title: "Origin",
      key: "origin",
      render: (rowdata) => {
        const bookeditem = parseJSON(rowdata?.bookeditem);
        return <div className="font-medium">{bookeditem?.origin}</div>;
      },
    },
    {
      title: "Destination",
      key: "destination",
      render: (rowdata) => {
        const bookeditem = parseJSON(rowdata?.bookeditem);
        return <div className="font-medium">{bookeditem?.destination}</div>;
      },
    },
    {
      title: "Ch. Wt",
      key: "chargeableWeight",
      render: (rowdata) => {
        const bookeditem = parseJSON(rowdata?.bookeditem);
        const chWt =
          rowdata?.queryDetails?.packagingDetails?.shipmentTotal
            ?.chargeableWeight ?? bookeditem?.rateDetails?.chargeableWeight;
        return (
          <div className="font-medium">
            {chWt != null && chWt !== "" ? Math.ceil(Number(chWt)) : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Cargo Ready Date",
      key: "cargoReadyDate",
      render: (rowdata) => {
        const date = rowdata?.queryDetails?.goodsDetails?.cargoreadydate;
        return <div>{date || "N/A"}</div>;
      },
    },
    {
      title: "Cancelled Date",
      key: "cancelled_date",
      align: "center",
      render: (rowdata) => {
        const cancelledAt = rowdata?.deletedAt;
        // Convert the raw UTC deletedAt timestamp to IST (UTC+5:30) for the tooltip.
        const deletedAtIST = cancelledAt
          ? moment(cancelledAt).utcOffset("+05:30").format("DD MMM YYYY, h:mm A")
          : null;
        const content = (
          <div className="flex items-center justify-center gap-1 min-w-[120px]">
            <span>
              {cancelledAt ? moment(cancelledAt).format("DD/MM/YYYY") : "N/A"}
            </span>
            {deletedAtIST && (
              <ClockCircleOutlined className="text-gray-500 cursor-pointer" />
            )}
          </div>
        );
        return deletedAtIST ? (
          <Tooltip title={`Cancelled: ${deletedAtIST} IST`}>{content}</Tooltip>
        ) : (
          content
        );
      },
    },
    {
      title: "Total Rate",
      key: "totalRate",
      render: (record) => {
        return (
          <div>
            <span>{record?.total_amount?.toFixed(2)}</span>
          </div>
        );
      },
    },
    {
      title: "Query Type",
      key: "queryQuotingStatus",
      render: (rowdata) => {
        // console.log("rowdataQUERYTYPE",rowdata)
        // const bookeditem = parseJSON(rowdata.bookeditem);
        return rowdata?.queryDetails?.queryQuotingStatus || "N/A";
      },
      filters: [
        { text: "Manual", value: "Manual" },
        { text: "Automatic", value: "Automatic" },
      ],
      onFilter: (value, rowdata) => {
        // const bookeditem = parseJSON(rowdata.bookeditem);
        return rowdata?.queryDetails?.queryQuotingStatus === value;
      },
    },

    {
      title: "Booking Status",
      key: "booking_status",
      render: (rowdata) => {
        return (
          <span
            className={`flex justify-center text-sm font-bold leading-4 ${
              rowdata?.booking_status === "Booking Cancelled" ?? "text-red-700"
            }`}
          >
            {rowdata?.booking_status}
          </span>
        );
      },
    },
    {
      title: "Payment Status",
      key: "payment_status",
      render: (rowdata) => {
        return (
          <span
            className={`flex justify-center text-sm font-bold leading-4 ${
              rowdata?.payment_status === "Payment Confirmed"
                ? "text-[#00A124]"
                : rowdata?.payment_status === "Waiting for Confirmation" ||
                  rowdata?.payment_status === "Payment Pending"
                ? "text-primary"
                : "text-red-700"
            }`}
          >
            {rowdata?.payment_status}
          </span>
        );
      },
      filters: [
        {
          text: "Payment Confirmed",
          value: "Payment Confirmed",
        },
        {
          text: "Payment Rejected",
          value: "Payment Rejected",
        },
        {
          text: "Waiting for Confirmation",
          value: "Waiting for Confirmation",
        },
        {
          text: "Refund Completed",
          value: "Refund Completed",
        },
      ],
      onFilter: (value, record) => record.payment_status.includes(value),
    },
    {
      title: "Payment Type",
      key: "payment_type",
      dataIndex: "payment_type",
      filters: [
        {
          text: "Online",
          value: "Online",
        },
        {
          text: "Offline",
          value: "Offline",
        },
        {
          text: "Credit",
          value: "Credit",
        },
        {
          text: "Credit + Online",
          value: "Credit + Online",
        },
        {
          text: "Credit + Ofline",
          value: "Credit + Ofline",
        },
      ],
      onFilter: (value, record) => record.payment_type.includes(value),
    },

    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space>
          <ViewButton handleClick={() => handleView(record)} data={record} />
        </Space>
      ),
    },
  ];

  // Origin / destination for an ocean booking. The cancelled-bookings list can
  // nest the ocean payload under `bookeditem` (ocean_offer / ocean_schedule) or
  // carry it at the row level, so check both plus the query document — same
  // fallback chain OceanCargoList/OceanCargoDetails use.
  const getOceanLocation = (rowdata, key) => {
    const bookeditem = parseJSON(rowdata?.bookeditem);
    const schedule = bookeditem?.ocean_schedule || rowdata?.ocean_schedule;
    const offer = bookeditem?.ocean_offer || rowdata?.ocean_offer;
    const sq =
      rowdata?.queryDetails ||
      bookeditem?.search_query_data ||
      rowdata?.search_query_data;
    if (key === "origin") {
      return (
        schedule?.fromLocation?.portName ||
        schedule?.fromLocation?.unLocCode ||
        offer?.productOffer?.originPort ||
        sq?.originPort?.originPort ||
        sq?.originPort?.originLocation ||
        "N/A"
      );
    }
    return (
      schedule?.toLocation?.portName ||
      schedule?.toLocation?.unLocCode ||
      offer?.productOffer?.destinationPort ||
      sq?.destinationPort?.destinationPort ||
      sq?.destinationPort?.destinationLocation ||
      "N/A"
    );
  };

  // Columns for the Ocean Cargo tab. Mirrors the Ocean booking-history layout
  // (no Ch. Wt / Cargo Ready Date columns, ocean-specific origin/destination
  // + ship logo); status colouring matches OceanCargoList.jsx.
  const oceanColumns = (currentPage, pageSize) => [
    {
      title: "Sr. No.",
      key: "slno",
      render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: "Cargo",
      key: "cargo",
      render: (rowdata) => {
        const bookeditem = parseJSON(rowdata?.bookeditem);
        return (
          <div className="rounded-lg w-14 h-14 flex items-center justify-center">
            <img
              src={bookeditem?.logo || shipicon}
              alt="Carrier Logo"
              className="rounded-lg overflow-hidden w-full"
            />
          </div>
        );
      },
    },
    {
      title: "Origin",
      key: "origin",
      render: (rowdata) => (
        <div className="font-medium">{getOceanLocation(rowdata, "origin")}</div>
      ),
    },
    {
      title: "Destination",
      key: "destination",
      render: (rowdata) => (
        <div className="font-medium">
          {getOceanLocation(rowdata, "destination")}
        </div>
      ),
    },
    {
      title: "Cancelled Date",
      key: "cancelled_date",
      align: "center",
      render: (rowdata) => {
        const cancelledAt = rowdata?.deletedAt;
        const deletedAtIST = cancelledAt
          ? moment(cancelledAt).utcOffset("+05:30").format("DD MMM YYYY, h:mm A")
          : null;
        const content = (
          <div className="flex items-center justify-center gap-1 min-w-[120px]">
            <span>
              {cancelledAt ? moment(cancelledAt).format("DD/MM/YYYY") : "N/A"}
            </span>
            {deletedAtIST && (
              <ClockCircleOutlined className="text-gray-500 cursor-pointer" />
            )}
          </div>
        );
        return deletedAtIST ? (
          <Tooltip title={`Cancelled: ${deletedAtIST} IST`}>{content}</Tooltip>
        ) : (
          content
        );
      },
    },
    {
      title: "Total Rate",
      key: "totalRate",
      render: (record) => (
        <div className="flex justify-center min-w-[120px]">
          <span>{record?.total_amount?.toFixed(2)}</span>
        </div>
      ),
    },
    {
      title: "Query Type",
      key: "queryQuotingStatus",
      render: (rowdata) => rowdata?.queryDetails?.queryQuotingStatus || "N/A",
      filters: [
        { text: "Manual", value: "Manual" },
        { text: "Automatic", value: "Automatic" },
      ],
      onFilter: (value, rowdata) =>
        rowdata?.queryDetails?.queryQuotingStatus === value,
    },
    {
      title: "Booking Status",
      key: "booking_status",
      render: (rowdata) => (
        <span
          className={`flex justify-center text-sm font-bold leading-4 ${
            rowdata?.booking_status === "Booking Confirmed"
              ? "text-[#00A124]"
              : rowdata?.booking_status === "Booking Pending"
              ? "text-primary"
              : rowdata?.booking_status === "Booking Cancelled"
              ? "text-red-700"
              : "text-orange-600"
          }`}
        >
          {rowdata?.booking_status}
        </span>
      ),
    },
    {
      title: "Payment Status",
      key: "payment_status",
      render: (rowdata) => (
        <span
          className={`flex justify-center text-sm font-bold leading-4 ${
            rowdata?.payment_status === "Payment Confirmed"
              ? "text-[#00A124]"
              : rowdata?.payment_status === "Waiting for Confirmation" ||
                rowdata?.payment_status === "Payment Pending"
              ? "text-primary"
              : "text-red-700"
          }`}
        >
          {rowdata?.payment_status}
        </span>
      ),
      filters: [
        { text: "Payment Confirmed", value: "Payment Confirmed" },
        { text: "Payment Rejected", value: "Payment Rejected" },
        { text: "Waiting for Confirmation", value: "Waiting for Confirmation" },
        { text: "Refund Completed", value: "Refund Completed" },
      ],
      onFilter: (value, record) => record?.payment_status?.includes(value),
    },
    {
      title: "Payment Type",
      key: "payment_type",
      dataIndex: "payment_type",
      filters: [
        { text: "Online", value: "Online" },
        { text: "Offline", value: "Offline" },
        { text: "Credit", value: "Credit" },
        { text: "Credit + Online", value: "Credit + Online" },
        { text: "Credit + Ofline", value: "Credit + Ofline" },
      ],
      onFilter: (value, record) => record?.payment_type?.includes(value),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space>
          <ViewButton handleClick={() => handleView(record)} data={record} />
        </Space>
      ),
    },
  ];

  // Split the single cancelled-bookings response by cargo type for the toggle.
  const airData = (data || []).filter((r) => !isOceanRecord(r));
  const oceanData = (data || []).filter((r) => isOceanRecord(r));

  const handleFilterChange = (value) => {
    setState((prevState) => {
      return {
        ...prevState,
        filter_value: "Query_status",
        status: value,
      };
    });
  };
  const getfiltereddata = (search) => {
    console.log(search, "search");
    dispatch(getcancelhistorysearch(search))
      .then((res) => {
        console.log("Cancelled bookings:", res?.payload);
        setData(res?.payload?.data?.data);
      })
      .catch((err) => {
        console.error("Error fetching cancel history:", err);
      });
  };
  function filterByDateRange(fromDate, toDate) {
    const from_date = new Date(fromDate);
    const to_date = new Date(toDate);
    const from = new Date(
      from_date.getFullYear(),
      from_date.getMonth(),
      from_date.getDate()
    );
    console.log(from, "from date");
    const to = new Date(
      to_date.getFullYear(),
      to_date.getMonth(),
      to_date.getDate()
    );
    console.log(to, "to date");
    return {
      from,
      to,
    };
  }
  
  const buildQueryParams = () => {
    if (searchValue) {
      return `?search=${encodeURIComponent(searchValue.trim())}`;
    }
    const { from_date, to_date } = state;
    if (from_date && to_date) {
      const daterange = filterByDateRange(from_date, to_date);

      if (daterange.from && daterange.to) {
        return `?from=${moment(daterange.from).format(
          "YYYY-MM-DD"
        )}&to=${moment(daterange.to).format("YYYY-MM-DD")}`;
      }
      // }
    }

    return ""; // No filter
  };

  const onSearch = (value) => {
    setSearchValue(value);
    // const { from_date, to_date } = state;
    // console.log(from_date, to_date,"date range");
    // if (debounceTimer) clearTimeout(debounceTimer);

    // debounceTimer = setTimeout(() => {
    //       // const queryString = buildQueryParams();
    //   // console.log(queryString, "search value"); // Just 'lhr' or any other text
    //   // getfiltereddata(queryString);
    //  }, 700);
  };
  const handleSearch = () => {
    const queryString = buildQueryParams();
    console.log(queryString, "search value");
    if (queryString) {
      getfiltereddata(queryString);
    }else if(!searchValue){
      getfiltereddata("");
    }
  };
  useEffect(() => {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      handleSearch();
      
    }, 700);
    // if(searchValue.length<=1||searchValue.length===0||searchValue===null||searchValue===undefined||!searchValue){
    //     handleSearch();
    //   }
    
    
  }, [state,searchValue]);

  return (
    <section className="cancellBookingsMain">
    <MainContainer>
      <CustomeHeader title="Cancelled Bookings" />
      <div className="mt-4 bg-white p-4 shadow-cardsection">
        <div className="flex items-center justify-between mt-4 mb-4">
          <div className="queryListSearch mr-60 flex-1 items-start justify-start w-22">
            <SearchBox onSearch={onSearch} />
          </div>
          <div class="datesearchbyquery mr-2 ml-2">
            <DateSection>
              {/*  */}
              <FilterSection>
                <LabelItem>From</LabelItem>
                <FilterDatePicker
                  name="from_date"
                  setState={setState}
                  filter_value="date_range"
                  maxDate={state?.to_date}
                />
              </FilterSection>
              <FilterSection>
                <LabelItem>To</LabelItem>
                <FilterDatePicker
                  name="to_date"
                  setState={setState}
                  filter_value="date_range"
                  minDate={state?.from_date} // Pass the selected "From Date" here
                  disabled={!state?.from_date}
                  onChange={() => handleFilterChange("date_range")}
                />
              </FilterSection>
            </DateSection>
          </div>
        </div>

        {/* Air / Ocean toggle — the whole cancelled list comes from one API,
            so each tab just renders the same table with cargo-type-filtered
            data and its own column set. */}
        <div className="mt-4 tableResponsiveASAP">
          <Tabs
            activeKey={selectedTab}
            type="card"
            onChange={(key) => {
              setSelectedTab(key);
              setCurrentPage(1);
            }}
            items={[
              {
                key: "Air Cargo",
                label: "Air Cargo",
                children: (
                  <Table
                    columns={columns(currentPage, pageSize)}
                    dataSource={airData}
                    pagination={{
                      current: currentPage,
                      pageSize: pageSize,
                      onChange: (page, size) => {
                        setCurrentPage(page);
                        setPageSize(size);
                      },
                    }}
                    rowKey={(record) => record?.queryId}
                    scroll={{ x: 1024 }}
                  />
                ),
              },
              {
                key: "Ocean Cargo",
                label: "Ocean Cargo",
                children: (
                  <Table
                    columns={oceanColumns(currentPage, pageSize)}
                    dataSource={oceanData}
                    pagination={{
                      current: currentPage,
                      pageSize: pageSize,
                      onChange: (page, size) => {
                        setCurrentPage(page);
                        setPageSize(size);
                      },
                    }}
                    rowKey={(record) => record?.queryId}
                    scroll={{ x: 1024 }}
                  />
                ),
              },
            ]}
          />
        </div>
      </div>
      {/* One detail modal for both tabs — it swaps its tab set and field
          mapping (AWB/flight/dimensions vs MBL/schedule/containers) off
          `isOcean`. */}
      {openview && (
        <CancelledBookingDetailsModal
          queryid={delqueryid}
          isOcean={viewIsOcean}
          cancelledAt={viewCancelledAt}
          onClose={() => setOpenview(false)}
        />
      )}
    </MainContainer>
    </section>
  );
};

export default Bookingdeletetable;
